import { registerIconFont } from 'LocalGluons/components/Icon/registerFont';

const fontName = 'materialCommunityIcons';

const fontIcon = require('react-native-vector-icons/MaterialCommunityIcons').default;
const fontTTL = require('react-native-vector-icons/Fonts/MaterialCommunityIcons.ttf');

export default () => registerIconFont(fontName, fontIcon, fontTTL, 'MaterialCommunityIcons');
